<template>
    <div class="slice page-mobile-app">
        <div class="slice-content">
            <MaltImg
                src="/rebranding2020/illustrations/digital-worker-man-2x"
                alt="Freelancers mobile illustration | Malt"
                width="205"
                class="page-illustration"
            />
            <h1 class="slice-title joy-mt-8">{{ t('landing.mobile.content.title') }}</h1>
            <div class="app-links">
                <a :href="appStoreLink" target="_blank">
                    <MaltImg :src="appStoreLogo" width="210" quality="90" alt="Malt mobile app appstore | Malt" />
                </a>
                <a :href="googlePlayLink" target="_blank">
                    <MaltImg :src="googlePlayLogo" width="210" quality="90" alt="Malt mobile app googleplay | Malt" />
                </a>
            </div>
            <div class="text-center joy-mt-8">
                <VJoyButton type="submit" :href="$withLocalePrefix('/')" variant="secondary">
                    {{ t('landing.mobile.continue') }}
                </VJoyButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import {ref} from 'vue';
    import {MaltImg} from '#components';
    import {useLocale, useTranslation} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';

    const {t} = useTranslation();
    const {locale} = useLocale();

    const appStoreLink = ref('https://apps.apple.com/fr/app/malt-freelance/id1458135616');
    const googlePlayLink = ref('https://play.google.com/store/apps/details?id=com.malt.app');

    const appStoreLogo = ref('/landing-mobile/appstore_logo-english');
    const googlePlayLogo = ref('/landing-mobile/googleplay_logo-english');

    if (locale.value === 'fr') {
        appStoreLogo.value = '/landing-mobile/appstore_logo-french';
        googlePlayLogo.value = '/landing-mobile/google-play-badge';
    }
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .page-mobile-app {
        .page-illustration {
            width: 120px;
            @include mq.screen_sm(min) {
                width: 205px;
            }
        }
        .app-links {
            display: inline-flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: var(--joy-core-spacing-4);
            margin: 0 auto;

            a,
            img {
                display: inline-block;
                height: 40px;
                @include mq.screen_sm(min) {
                    height: 50px;
                }
            }
        }
    }
</style>
